import { render, staticRenderFns } from "./CurrentPlanDetails.vue?vue&type=template&id=e4996970&"
import script from "./CurrentPlanDetails.vue?vue&type=script&lang=js&"
export * from "./CurrentPlanDetails.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPlanDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports